/**
 * Asteroid mix entries configuration
 *
 * This file is auto-generated by the balance importer.
 * Do not edit manually - changes will be overwritten.
 *
 * Generated at: 2025-09-25T12:43:18.993Z
 */

import { ConfigType } from './ConfigType';

export interface AsteroidMixEntryConfig {
  asteroid_mix_id: string;
  asteroid_id: string;
  size_id: string;
  weight: number;
  configType: ConfigType.ASTEROID_MIX_ENTRIES;
}

export const asteroidMixEntriesData: AsteroidMixEntryConfig[] = [
  {
    asteroid_mix_id: 'MIX_AURORA',
    asteroid_id: 'AST_BSLT',
    size_id: 'SZ_PEB',
    weight: 40,
    configType: ConfigType.ASTEROID_MIX_ENTRIES,
  },
  {
    asteroid_mix_id: 'MIX_AURORA',
    asteroid_id: 'AST_BSLT',
    size_id: 'SZ_S',
    weight: 30,
    configType: ConfigType.ASTEROID_MIX_ENTRIES,
  },
  {
    asteroid_mix_id: 'MIX_AURORA',
    asteroid_id: 'AST_QTZ',
    size_id: 'SZ_S',
    weight: 20,
    configType: ConfigType.ASTEROID_MIX_ENTRIES,
  },
  {
    asteroid_mix_id: 'MIX_AURORA',
    asteroid_id: 'AST_QTZ',
    size_id: 'SZ_M',
    weight: 6,
    configType: ConfigType.ASTEROID_MIX_ENTRIES,
  },
  {
    asteroid_mix_id: 'MIX_FLUX',
    asteroid_id: 'AST_QTZ',
    size_id: 'SZ_S',
    weight: 35,
    configType: ConfigType.ASTEROID_MIX_ENTRIES,
  },
  {
    asteroid_mix_id: 'MIX_FLUX',
    asteroid_id: 'AST_QTZ',
    size_id: 'SZ_M',
    weight: 20,
    configType: ConfigType.ASTEROID_MIX_ENTRIES,
  },
  {
    asteroid_mix_id: 'MIX_FLUX',
    asteroid_id: 'AST_FRR',
    size_id: 'SZ_S',
    weight: 18,
    configType: ConfigType.ASTEROID_MIX_ENTRIES,
  },
  {
    asteroid_mix_id: 'MIX_FLUX',
    asteroid_id: 'AST_FRR',
    size_id: 'SZ_M',
    weight: 15,
    configType: ConfigType.ASTEROID_MIX_ENTRIES,
  },
  {
    asteroid_mix_id: 'MIX_FLUX',
    asteroid_id: 'AST_BSLT',
    size_id: 'SZ_S',
    weight: 8,
    configType: ConfigType.ASTEROID_MIX_ENTRIES,
  },
  {
    asteroid_mix_id: 'MIX_FLUX',
    asteroid_id: 'AST_VEIN',
    size_id: 'SZ_M',
    weight: 4,
    configType: ConfigType.ASTEROID_MIX_ENTRIES,
  },
  {
    asteroid_mix_id: 'MIX_LUMEN',
    asteroid_id: 'AST_LUM',
    size_id: 'SZ_M',
    weight: 36,
    configType: ConfigType.ASTEROID_MIX_ENTRIES,
  },
  {
    asteroid_mix_id: 'MIX_LUMEN',
    asteroid_id: 'AST_LUM',
    size_id: 'SZ_L',
    weight: 14,
    configType: ConfigType.ASTEROID_MIX_ENTRIES,
  },
  {
    asteroid_mix_id: 'MIX_LUMEN',
    asteroid_id: 'AST_FRR',
    size_id: 'SZ_M',
    weight: 20,
    configType: ConfigType.ASTEROID_MIX_ENTRIES,
  },
  {
    asteroid_mix_id: 'MIX_LUMEN',
    asteroid_id: 'AST_QTZ',
    size_id: 'SZ_S',
    weight: 18,
    configType: ConfigType.ASTEROID_MIX_ENTRIES,
  },
  {
    asteroid_mix_id: 'MIX_LUMEN',
    asteroid_id: 'AST_BSLT',
    size_id: 'SZ_S',
    weight: 8,
    configType: ConfigType.ASTEROID_MIX_ENTRIES,
  },
  {
    asteroid_mix_id: 'MIX_LUMEN',
    asteroid_id: 'AST_VEIN',
    size_id: 'SZ_L',
    weight: 4,
    configType: ConfigType.ASTEROID_MIX_ENTRIES,
  },
];

/**
 * Get all AsteroidMixEntryConfig entries
 */
export function getAllAsteroidMixEntries(): AsteroidMixEntryConfig[] {
  return asteroidMixEntriesData;
}
